<template>
  <b-container fluid id="events" class="page">
    <div class="title d-flex justify-content-between align-items-center flex-wrap">
      <h1>Events</h1>
    </div>

    <div v-if="this.events.length !== 0">
      <div v-for="event in this.events" :key="event.id">
        <event :event_data="event"></event>
      </div>
    </div>
    <div v-else id="no-data" class="d-flex">
      <span><font-awesome icon="exclamation" fixed-width /></span>
      <p>No events have been added yet!</p>
    </div>
  </b-container>
</template>

<script>
import Event from "@/components/Event.vue";

export default {
  name: "Events",
  components: {
    Event
  },
  created() {
    this.events = this.page.get_events
      .filter(
        function (event) {
          return event.breast === true;
        }.bind(this)
      )
      .sort((e1, e2) => {
        const d1 = Date.parse(e1.date_end);
        const d2 = Date.parse(e2.date_end);

        if (d1 > d2) {
          return -1;
        }

        if (d1 < d2) {
          return 1;
        }

        return 0;
      });
  },
  data() {
    return {
      pages: null,
      events: [],
    };
  },
  props: ["page"]
};
</script>
